import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "@/assets/scss/material-kit.scss";
import "@/assets/demo.css";
import globalMixins from "./globalMixins";
import basicMixins from "./basicMixins";
import globalComponents from "./globalComponents";
import Notifications from "@/components/NotificationPlugin";
import globalDirectives from "./globalDirectives";

export default {
  install(Vue) {
    Vue.use(VueMaterial);
    Vue.use(globalMixins);
    Vue.use(basicMixins);
    Vue.use(globalComponents);
    Vue.use(Notifications);
    Vue.use(globalDirectives);
  }
};
